<template>
  <div class="ConsignmentSummaryReportQtyTable">
    <Table width="200" border :columns="periodColumnsList" :data="periodData" v-if="periodDateStr">
    </Table>
    <TablePage 
      :pageObj="pageObj"
      @changePage="changePage"
      :tableWidth="windowWidth" 
      :columnsList="columnsList" 
      :resultList="showData" 
      v-if="isData">
    </TablePage>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "ConsignmentSummaryReportQtyTable",
  created() {
  },
  data() {
    return {
      pageObj: {
        "page": 0,
        "totalPage": 0,
        "totalCount": 0,
        "pageSize": 20
      },
      periodColumnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("PERIOD");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'period',
          width: 80,
          align: "center",
        },
      ],
      columnsList: [
        {
          renderHeader: (h, params) => {
            var text = this.$t("ITEM");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: 'P/N',
          key: 'pn',
          width: 80,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VENDOR_PN");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendorPn',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("VN_CODE");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'vendorCode',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BEGIN_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'beginQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RECEIVE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'receivingQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("RETURN_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'returnQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("ISSUE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'issueQty',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("BALANCE_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'balance',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          renderHeader: (h, params) => {
            var text = this.$t("IQC_STOCK");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'iqcStock',
          width: 100,
          sortable: true,
          align: "center",
        },
        {
          
          renderHeader: (h, params) => {
            var text = this.$t("BLOCKED_STOCK_QTY");
            return h('div', {
              domProps: {
                innerHTML: text
              }
            })
          },
          key: 'blockStock',
          width: 100,
          sortable: true,
          align: "center",
        }
      ],
    }
  },
  methods: {
    ...mapGetters(["getWindowsWidth"]),
    changePage(page) {
      this.pageObj.page = page - 1
    }
  },
  computed: {
    isData() {
      return this.dataList && this.dataList.length > 0
    },
    windowWidth() {
      return this.getWindowsWidth() - 70
    },
    periodData() {
      return [{
        period: this.periodDateStr
      }]
    },
    showData() {
      return this.dataList.slice(this.pageObj.page, this.pageObj.page + this.pageObj.pageSize)
    }
  },
  watch: {
    dataList: {
      handler: function(newValue, oldValue) {
        this.pageObj.totalCount = newValue.length
        this.pageObj.totalPage = newValue.length / this.pageObj.pageSize == 0 ? parseInt(newValue.length / this.pageObj.pageSize) : parseInt(newValue.length / this.pageObj.pageSize) + 1
      },
      deep: true,
      immediate: true
    }
  },
  props: {
    title: String,
    content: String,
    periodDateStr: String,
    dataList: Array,
  },
}
</script>

<style scoped>

</style>